import React from 'react'

export default () => (
  <a className="fb-icon" href="http://facebook.com/spytajsavasich" rel="noopener noreferrer" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.412 42.249"><path d="M29.115,0H11.3A11.288,11.288,0,0,0,0,11.3V30.953a11.288,11.288,0,0,0,11.3,11.3h6.8v-16.8H14.606v-4.69h3.487V18.643c0-5.235,3.031-8.082,8.634-8.082a14.524,14.524,0,0,1,3.487.368V15.98a17.835,17.835,0,0,0-2.2-.184,2.689,2.689,0,0,0-2.939,3.031v1.929h5.143v4.684h-5.14v16.8h3.949a11.307,11.307,0,0,0,11.389-11.3V11.3A11.288,11.288,0,0,0,29.115,0Z" /></svg>
  </a>
)



// WEBPACK FOOTER //
// ./src/components/Header/Fb.js